var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("CopyRight 2020  广东南方周末经营有限公司")]),_c('p',[_vm._v("版本"),_c('span',[_vm._v("v"+_vm._s(_vm.version))]),_c('span',[_vm._v(" | ")]),_vm._v("构建版本："),_c('span',[_vm._v(_vm._s(_vm.buildAt))])])])}
var staticRenderFns = []

export { render, staticRenderFns }